import { jsx as _jsx } from "react/jsx-runtime";
import { FeedbackMessage } from "@gemini/ui";
export const Message = ({ message }) => {
    if (!message)
        return null;
    return (_jsx(FeedbackMessage, { marginVertical: "spacing.16", variant: message.type === "INFO" ? "info" : "success", children: message.value }));
};
